import * as Tabs from './tabs';
import {
    SettingsRounded,
    SignalCellularAltRounded,
    ContactMailRounded,
    QueryStatsRounded,
    TrendingUp,
    DeleteRounded,
    LanguageRounded,
} from '@mui/icons-material';

const settingsTabs = [
    {   
        id: 0,
        slug: 'general',
        label: 'General',
        icon: <SettingsRounded/>,
        component: <Tabs.General />,
    },
    {   
        id: 1,
        slug: 'statistics',
        label: 'Statistics',
        icon: <SignalCellularAltRounded/>,
        component: <Tabs.Statistics />,
    },
    {   
        id: 10,
        slug: 'domains',
        label: 'Domains',
        icon: <LanguageRounded/>,
        component: <Tabs.Domains />,
    },
    {   
        id: 2,
        slug: 'forgotten',
        label: 'Forgotten',
        disableTitleIntegration: true, // Title will not be added (integrated) to the page automatically
        icon: <DeleteRounded/>,
        component: <Tabs.Forgotten />,
    },
    {   
        id: 21, 
        slug: 'metrics',
        label: 'Metrics',
        icon: <QueryStatsRounded/>,
        component: <Tabs.Metrics />,
        adminOnly: true,
    },
    {   
        id: 22, 
        slug: 'trends',
        label: 'Trends',
        icon: <TrendingUp/>,
        component: <Tabs.Trends />,
        adminOnly: true,
    },
    {   
        id: 3, 
        slug: 'contact',
        label: 'Contact us',
        icon: <ContactMailRounded/>,
        component: <Tabs.Contact />,
    },
]

export default settingsTabs;